const pageNameKey = "nodeManager";

export const nodeManagerPageEn = {
  [pageNameKey]: {
    backToSourcesList: "Machines List",
    oneClickToggleButtonWrapper: {
      blueprint: "Blueprint",
      oneClickSolution: "One Click Solution",
    },
    backToNodeManager: "Node Manager",
    componentNotFound: "Component not found",
    loadingError: "Failed to load structures",
    initialStructureEmpty:
      "The initial node structure is currently being read from the OPC-UA server and transmitted to the platform.",
  },
};

export const nodeManagerPagePtBr = {
  [pageNameKey]: {
    backToSourcesList: "Lista de máquinas",
    oneClickToggleButtonWrapper: {
      blueprint: "Projeto",
      oneClickSolution: "Solução com um clique",
    },
    backToNodeManager: "Gerenciador de nós",
    componentNotFound: "Componente não encontrado",
    loadingError: "Falha ao carregar estruturas",
    initialStructureEmpty:
      "A estrutura inicial dos nós está sendo lida do servidor OPC-UA e transmitida para a plataforma.",
  },
};

export const nodeManagerPageDe = {
  [pageNameKey]: {
    backToSourcesList: "Maschinen-Liste",
    oneClickToggleButtonWrapper: {
      blueprint: "Blueprint",
      oneClickSolution: "Ein-Klick-Lösung",
    },
    backToNodeManager: "Node Manager",
    componentNotFound: "Komponente nicht gefunden",
    loadingError: "Strukturen konnten nicht geladen werden",
    initialStructureEmpty:
      "Die anfängliche Knotenstruktur wird derzeit vom OPC-UA-Server gelesen und an die Plattform übertragen.",
  },
};

export const nodeManagerPageZhHans = {
  [pageNameKey]: {
    backToSourcesList: "机器列表",
    oneClickToggleButtonWrapper: {
      blueprint: "蓝图",
      oneClickSolution: "一键解决方案",
    },
    backToNodeManager: "节点管理器",
    componentNotFound: "未找到组件",
    loadingError: "加载结构失败",
    initialStructureEmpty: "初始节点结构目前正从OPC-UA服务器读取并传输到平台。",
  },
};

export const nodeManagerPageIt = {
  [pageNameKey]: {
    backToSourcesList: "Elenco macchine",
    oneClickToggleButtonWrapper: {
      blueprint: "Blueprint",
      oneClickSolution: "Applica con un clic",
    },
    backToNodeManager: "Gestore nodi",
    componentNotFound: "Componente non trovato",
    loadingError: "Impossibile caricare le strutture",
    initialStructureEmpty:
      "La struttura iniziale dei nodi viene attualmente letta dal server OPC-UA e trasmessa alla piattaforma.",
  },
};

export const nodeManagerPageEs = {
  [pageNameKey]: {
    backToSourcesList: "Lista de máquinas",
    oneClickToggleButtonWrapper: {
      blueprint: "Plano",
      oneClickSolution: "Solución con un clic",
    },
    backToNodeManager: "Administrador de nodos",
    componentNotFound: "Componente no encontrado",
    loadingError: "No se pudieron cargar las estructuras",
    initialStructureEmpty:
      "La estructura inicial de nodos se está leyendo actualmente del servidor OPC-UA y transmitiendo a la plataforma.",
  },
};

export const nodeManagerPageNl = {
  [pageNameKey]: {
    backToSourcesList: "Machinelijst",
    oneClickToggleButtonWrapper: {
      blueprint: "Blueprint",
      oneClickSolution: "Oplossing met één klik",
    },
    backToNodeManager: "Node Manager",
    componentNotFound: "Component niet gevonden",
    loadingError: "Structuren konden niet worden geladen",
    initialStructureEmpty:
      "De initiële nodestructuur wordt momenteel van de OPC-UA-server gelezen en naar het platform verzonden.",
  },
};

export const nodeManagerPageTr = {
  [pageNameKey]: {
    backToNodeManager: "Bağlantı Noktası Yöneticisi",
    backToSourcesList: "Makine Listesi",
    oneClickToggleButtonWrapper: {
      blueprint: "Taslak",
      oneClickSolution: "Tek Tıklamayla Çözüm",
    },
    componentNotFound: "Bileşen bulunamadı",
    initialStructureEmpty:
      "İlk düğüm yapısı şu anda OPC-UA sunucusundan okunuyor ve platforma aktarılıyor.",
    loadingError: "Yapılar yüklenemedi",
  },
};
